import React from 'react';
import { motion } from 'framer-motion';
import {
  DollarSign,
  LayoutDashboard,
  Upload,
  PiggyBank,
  Sparkles,
  Shield,
} from 'lucide-react';

const navItems = [
  { key: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { key: 'upload', label: 'Upload', icon: Upload },
  { key: 'planner', label: 'Planner', icon: PiggyBank },
  { key: 'categorize', label: 'Categorize', icon: Sparkles },
  { key: 'admin', label: 'Admin', icon: Shield },
];

const Header = ({ onNavClick, activeView }) => (
  <header className="sticky top-0 z-40 border-b border-white/10 bg-slate-900/40 backdrop-blur-xl">
    <div className="mx-auto flex w-full max-w-7xl items-center justify-between px-4 py-5 md:px-8">
      <div className="flex items-center gap-3 text-white">
        <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-white/20 shadow-glow">
          <DollarSign size={24} />
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.35em] text-slate-300">Finance OS</p>
          <h1 className="font-display text-2xl font-semibold">MyFinManager</h1>
        </div>
      </div>

      <nav className="hidden items-center gap-2 rounded-full border border-white/10 bg-white/10 p-1 text-sm text-white md:flex">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = activeView === item.key;
          return (
            <button
              key={item.key}
              onClick={() => onNavClick(item.key)}
              className="relative overflow-hidden rounded-full px-4 py-2 font-medium"
            >
              {isActive && (
                <motion.span
                  layoutId="nav-pill"
                  className="absolute inset-0 rounded-full bg-white text-slate-900 shadow-glow"
                  transition={{ type: 'spring', stiffness: 500, damping: 40 }}
                />
              )}
              <span
                className={`relative z-10 flex items-center gap-2 ${
                  isActive ? 'text-slate-900' : 'text-slate-100/80'
                }`}
              >
                <Icon size={16} />
                {item.label}
              </span>
            </button>
          );
        })}
      </nav>

      <button
        onClick={() => onNavClick('upload')}
        className="inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-brand-500 via-fuchsia-500 to-sky-400 px-5 py-2.5 text-sm font-semibold text-white shadow-glow hover:opacity-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-900"
      >
        <Sparkles size={16} className="animate-pulse" />
        New Upload
      </button>
    </div>
    <div className="mx-auto mt-3 flex w-full max-w-7xl gap-2 overflow-x-auto px-4 pb-3 md:hidden">
      {navItems.map((item) => {
        const Icon = item.icon;
        const isActive = activeView === item.key;
        return (
          <button
            key={item.key}
            onClick={() => onNavClick(item.key)}
            className={`flex flex-shrink-0 items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold ${
              isActive ? 'bg-white text-slate-900 shadow-glow' : 'bg-white/10 text-white/80'
            }`}
          >
            <Icon size={16} />
            {item.label}
          </button>
        );
      })}
    </div>
  </header>
);

export default Header;
